import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import {
  getCurrentUser,
  getYearCards,
} from "../api/budgetPortal";
import { BUDGET_MODULE_PATHS } from "../constants/budgetModule";
import { useAuth } from "../state/AuthContext";
import {
  getSelectedBudgetModulePage,
  saveSelectedBudgetModuleYear,
  setBudgetFlowCompleted,
  setBudgetFlowStarted,
} from "../utils/budgetFlow";
import { isAccountantUser } from "../utils/userRole";
import { APP_NAME } from "../constants/app";
import { AppLoader } from "../components/Loaders";
import Logo from "../assets/image/logo.svg";

const getBudgetDestination = (yearCards = [], profile = null) => {
  if (isAccountantUser(profile)) {
    const assignedYear = yearCards.find((item) => item.has_workspace);
    if (assignedYear) {
      saveSelectedBudgetModuleYear(assignedYear.financial_year);
      setBudgetFlowCompleted();
      return BUDGET_MODULE_PATHS.planner;
    }

    return "";
  }

  const draftYear = yearCards.find((item) => item.has_import_draft);
  if (draftYear) {
    saveSelectedBudgetModuleYear(draftYear.financial_year);
    setBudgetFlowStarted();
    return BUDGET_MODULE_PATHS.mapping;
  }

  const workspaceYear = yearCards.find((item) => item.has_workspace);
  if (workspaceYear) {
    saveSelectedBudgetModuleYear(workspaceYear.financial_year);
    setBudgetFlowCompleted();
    return getSelectedBudgetModulePage() || BUDGET_MODULE_PATHS.dashboard;
  }

  return BUDGET_MODULE_PATHS.import;
};

const BudgetEntryPage = () => {
  const navigate = useNavigate();
  const { token, updateUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const enterBudgetFlow = async () => {
      setLoading(true);
      setError("");

      try {
        const userResponse = await getCurrentUser(token);
        const profile = userResponse?.data ?? null;
        updateUser(profile);

        if (!profile?.setup) {
          navigate("/setup", { replace: true });
          return;
        }

        const yearCardsResponse = await getYearCards(token);
        const destination = getBudgetDestination(
          yearCardsResponse?.data ?? [],
          profile,
        );

        if (!destination) {
          setError("No budget departments have been assigned to your account yet.");
          setLoading(false);
          return;
        }

        navigate(destination, { replace: true });
      } catch (entryError) {
        setError(
          entryError?.response?.data?.message ||
          entryError.message ||
          "Unable to enter the budget module.",
        );
        setLoading(false);
      }
    };

    enterBudgetFlow();
  }, [navigate, token, updateUser]);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <section className="splash-page">
      <div className="desktop-nav">
        <div className="desktop-navBrand">
          <img src={Logo} alt={APP_NAME} className="desktop-navLogo" />
          <p>{APP_NAME}</p>
        </div>
      </div>

      <div className="splash-bg">
        {loading ? (
          <AppLoader label="Starting Budget module..." variant="page" />
        ) : (
          <p>Budget module</p>
        )}
        {error ? <div className="web-inlineError">{error}</div> : null}
      </div>
    </section>
  );
};

export default BudgetEntryPage;
